<template>
    <section class="partners container">
        <div class="wrapper">
            <h2 class="partners__title">
                <span class="underlined-text">Retail</span> Partners
            </h2>
            <div class="partners-list">
                <a v-for="(partner, index) in partners" :key="index" class="partner-link" :href="partner.url">
                    <img :src="partner.imageUrl">
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    props: ['partners'],
    components: {
        Carousel,
        Slide
    }
}
</script>

<style lang="scss">
@import "@/assets/css/helpers-variables.scss";

.partners {
  text-align: center;
  margin-bottom: 80px;
  .wrapper {
    @media (max-width: 767px) {
      max-width: $phone-l;
    }
  }
}
.partners__title {
  font-size: 1.25em;
  font-weight: 600;
  line-height: 2.4;
  margin-bottom: 40px;
  @media (min-width: $laptop-s) {
    font-size: 2em;
  }
  @media (min-width: $laptop-l) {
    font-size: 2.2em;
  }
}
.partners-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.partner-link {
  display: block;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 40px;
  @media (min-width: $tablet) {
    width: 50%;
    margin-bottom: 60px;
  }
  @media (min-width: $laptop-s) {
    width: 25%;
    margin-bottom: 60px;
  }
  img {
    display: block;
    width: 60%;
  }
}
</style>
